<script lang="ts">
	import type { Snippet } from 'svelte';

	import Picture from '$lib/components/media/Picture.svelte';

	interface Props {
		image?: Snippet | { src: string; alt: string; classes?: Classes };
		children?: Snippet;
		class?: Classes;
	}

	let { class: classes = '', image, children }: Props = $props();
</script>

<div
	class={[
		'content-well border-gray flex flex-col items-center gap-4 border-y py-4 md:flex-row',
		classes
	]}
>
	<div class="grow-1">
		{@render children?.()}
	</div>

	{#if typeof image === 'function'}
		{@render image()}
	{:else if image}
		{@const { src, alt, classes } = image}
		<div class={[classes, 'shrink-0']}>
			<Picture lazy={false} {src} {alt} class="h-full w-full object-contain" />
		</div>
	{/if}
</div>
